import { Box, Chip, Tooltip } from '@mui/material';
import React from 'react';

import Text from '../../../base/text';

import { useDesignTokens } from '~/client/hooks/use-design-tokens';
import * as GQL from '~/graphql/generated/client';

// Policies attached above this project. They are published with it, so the tab shows them rather than leaving them to surprise anyone.

interface Props {
  projectId: string;
}

const MonitoringInheritedPolicies: React.FC<Props> = ({ projectId }) => {
  const t = useDesignTokens();
  const { data } = GQL.useGuardianInheritedPoliciesQuery({
    variables: { projectId },
    fetchPolicy: 'cache-and-network',
  });
  const inherited = data?.guardianInheritedPolicies ?? [];
  if (inherited.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 3 }}>
      <Text sz="body-demibold">Also published with this project</Text>
      <Text sz="body14" sx={{ color: t.textMuted, mb: 1 }}>
        These policies are attached above this project, so Publish now sends
        them to Witness too. To stop one applying here, remove it where it is
        attached.
      </Text>
      {inherited.map((policy) => (
        <Box
          key={policy.policyId}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            py: 1.25,
            borderTop: `1px solid ${t.borderSubtle}`,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Text fontWeight={500}>{policy.name}</Text>
            <Text sz="body14" sx={{ color: t.textMuted }}>
              {policy.controlCount}{' '}
              {policy.controlCount === 1 ? 'control' : 'controls'}
            </Text>
          </Box>
          <Tooltip
            title={
              policy.fromOrganization
                ? `Attached to ${policy.fromName}, your organization's own project, so every project inherits it.`
                : `Attached to ${policy.fromName}, which this project belongs to.`
            }
          >
            <Chip
              size="small"
              label={
                policy.fromOrganization
                  ? `From organization · ${policy.fromName}`
                  : `From ${policy.fromName}`
              }
            />
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
};

export default MonitoringInheritedPolicies;
